import { IFilterOption } from "../components/shared";
import { AMBER_TEXT_COLORS, NEUTRAL_TEXT_COLORS, RED_TEXT_COLORS, SPLOOT_BADGE_COLOR } from "../themes";

/**
 * Partner leave status enum
 */
export enum EPartnerLeaveStatusv4 {
    APPLIED = "APPLIED",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    CANCELLED = "CANCELLED",
}

/**
 * Job status enum
 * Represents the status of a calculation job in the processing queue
 */
export enum ERewardPenaltyStatusv4 {
    CALCULATED = "CALCULATED",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    CANCELLED = "CANCELLED",
}

/**
 * Enum for filterBy parameter - controls how leave status filters are applied
 */
export enum EPartnerLeaveFilterBy {
    /**
     * Active leaves: status=APPROVED AND current date overlaps with leave period
     */
    ACTIVE = "ACTIVE",

    /**
     * Upcoming leaves: leaves that haven't started yet (startsAt > now)
     */
    UPCOMING = "UPCOMING",

    /**
     * Completed leaves: leaves that have ended (endsAt < now)
     */
    COMPLETED = "COMPLETED",

    /**
     * All leaves: no date filtering
     */
    ALL = "ALL",
}

/**
 * Unified enum for all partner leave reasons
 * Used across partner and admin leave flows
 */
export enum EUnifiedPartnerLeaveReasonEnum {
    ADMIN_PARTNER_REQUEST_FOR_LEAVE = "ADMIN_PARTNER_REQUEST_FOR_LEAVE",
    ADMIN_PARTNER_NOT_REACHABLE = "ADMIN_PARTNER_NOT_REACHABLE",
    ADMIN_EMERGENCY = "ADMIN_EMERGENCY",
    ADMIN_HEALTH_ISSUE = "ADMIN_HEALTH_ISSUE",
    ADMIN_TRANSPORT_PROBLEM = "ADMIN_TRANSPORT_PROBLEM",
    ADMIN_OTHER = "ADMIN_OTHER",
}

/**
 * Filter option IDs for leave status filters
 */
export const LEAVE_STATUS_FILTER_OPTIONS_ID = {
    ALL_STATUSES: "all-statuses",
    ACTIVE: "active",
    UPCOMING: "upcoming",
    COMPLETED: "completed",
} as const;

/**
 * Quick filter options for leave status
 */
export const LEAVE_STATUS_FILTER_OPTIONS: IFilterOption[] = [
    {
        id: LEAVE_STATUS_FILTER_OPTIONS_ID.ALL_STATUSES,
        label: "All Statuses",
        default: true,
    },
    {
        id: LEAVE_STATUS_FILTER_OPTIONS_ID.ACTIVE,
        label: "Active",
    },
    {
        id: LEAVE_STATUS_FILTER_OPTIONS_ID.UPCOMING,
        label: "Upcoming",
    },
    {
        id: LEAVE_STATUS_FILTER_OPTIONS_ID.COMPLETED,
        label: "Completed",
    },
];

/**
 * Badge colors for leave status
 */
export const LEAVE_STATUS_BADGE_COLORS = {
    [EPartnerLeaveStatusv4.APPLIED]: SPLOOT_BADGE_COLOR.ORANGE,
    [EPartnerLeaveStatusv4.APPROVED]: SPLOOT_BADGE_COLOR.GREEN,
    [EPartnerLeaveStatusv4.REJECTED]: SPLOOT_BADGE_COLOR.RED,
    [EPartnerLeaveStatusv4.CANCELLED]: SPLOOT_BADGE_COLOR.NEUTRAL,
} as const;

/**
 * Badge colors for penalty status
 */
export const PENALTY_STATUS_BADGE_COLORS = {
    [ERewardPenaltyStatusv4.CALCULATED]: SPLOOT_BADGE_COLOR.BLUE,
    [ERewardPenaltyStatusv4.APPROVED]: SPLOOT_BADGE_COLOR.GREEN,
    [ERewardPenaltyStatusv4.REJECTED]: SPLOOT_BADGE_COLOR.RED,
    [ERewardPenaltyStatusv4.CANCELLED]: SPLOOT_BADGE_COLOR.NEUTRAL,
} as const;

/**
 * Text colors for penalty amount based on penalty status
 */
export const PENALTY_AMOUNT_COLORS: Record<ERewardPenaltyStatusv4, string> = {
    [ERewardPenaltyStatusv4.APPROVED]: RED_TEXT_COLORS[600],
    [ERewardPenaltyStatusv4.CALCULATED]: AMBER_TEXT_COLORS[600],
    [ERewardPenaltyStatusv4.REJECTED]: NEUTRAL_TEXT_COLORS[500],
    [ERewardPenaltyStatusv4.CANCELLED]: NEUTRAL_TEXT_COLORS[700],
} as const;